import { styled } from 'styled-components'
import Card from './juegos/card.jsx'
import CancelIcon from '@mui/icons-material/Cancel';


const Container=styled.div`
 	background-color:#1F1E1E;
 	width:80vw;
 	height:90vh;
 	border-radius:5px;
 	overflow:auto;
 	&::-webkit-scrollbar{
		background-color:transparent;
		width:3px
	};
	&::-webkit-scrollbar-track{
		background:trasparent;		
		border-radius:25px
	};
	&::-webkit-scrollbar-thumb {
    	background: #27B0FE;
    	border-radius: 15px;
  	};
  	&::-webkit-scrollbar:horizontal{display:none}

 `;

const Close=styled.div`
	position:absolute;
	 top:3vh;
	 right:4vw;
	 width:35px;
	 font-size: 40px;
	 &:hover{
	 	color:black;
	 	cursor:pointer
	 }

`;

const BasicData=styled.div`
	position:relative;
	display:flex;
 	justify-content:space-around;
 	align-items:center;
 	height:70%; 
 	border-radius:25px 25px 0px 0px;  
 	background-position:center;
 	background-size:100%;
 	@media (max-width: 768px){
    	flex-direction: column;
    	height:620px;
    	background-size:cover;
  	}
`;

const Overlay=styled.div`
	position: absolute;
    width: 100%;
    height: 100%;
    z-index:0;
    background: radial-gradient(circle at center, rgba(31, 30, 30, 0) 35%, rgba(31, 30, 30, 1) 100%);
    pointer-events: none;
`;

const ContainerCard=styled.div`
 	height:300px;
 	width:280px;
 	z-index:1;
 	border:1px solid white;
 	border-radius:8px 8px 0px 0px;
 	box-shadow: 2px 1px 10px black;
	
`;



const DetallesJuego=styled.div`
	width:55%;
	background-color:#000000;
	border:1px solid white;
	height:60%;
	min-height:285px;
	border-radius:10px;
	display:flex;
	flex-direction:column;
	justify-content:center;
	align-items:center;
	text-align:center;
	z-index:1;
	font-size:18px;
`;

const ContainerCategorias=styled.div`
	margin:15px;
	display:flex;
	flex-wrap:wrap;
	
`;

const Categoria=styled.label`
	background-color:#323232;
	margin:10px;
	padding:8px;
	border-radius:15px;

	

`;

const ContainerPresentacion = styled.div`

  width: 95%;
  flex-wrap: wrap;
  text-align:left;
  padding:25px;
  white-space: pre-wrap;
  @media (max-width: 768px) {
		padding:15px
	}
`;

const Presentacion = styled.div`
  height: 400px;
  margin: 0px 45px 20px 0px;   
  width:61%;
  float:left;
  @media (max-width: 768px) {
   	float:none;
   	width:100%;
  }
`;




export default function JuegoOfertaDetalle(props){
	let { juego,close } = props;

 

	return(
		<Container>
			<Close onClick={close}><CancelIcon fontSize="50px"/></Close>
			{juego?<BasicData style={{backgroundImage:`url(${juego.poster})`}}> 
				<Overlay/>
				<ContainerCard>
					<Card consola={juego.consola} poster={juego.poster} / >
				</ContainerCard>
				<DetallesJuego>
					<div><b>{juego.nombre}</b></div>
					<div><b>audio : </b>{juego.audio}</div>
					<div><b>subtitulos : </b>{juego.subtitulos}</div>
					<div><b>peso : </b>{juego.peso}</div>
					<div><b>players OffLine : </b>{juego.multiplayerOffLine} </div>
					<div><b>players OnLine : </b>{juego.multiplayerOnLine} </div>
					<ContainerCategorias>{juego.Categoria.map(cate=><Categoria key={cate.id}>{cate.nombre}</Categoria>)}</ContainerCategorias>

				</DetallesJuego>
			</BasicData>:null}
			<ContainerPresentacion>
				{juego.videopresentacion?
				<Presentacion>
					<iframe 
						width="100%" 
						height="400px" 
						src={juego.videopresentacion} 
						title="YouTube video player" 
						frameBorder="0" 
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
						referrerpolicy="strict-origin-when-cross-origin" allowFullScreen>					
					</iframe>

				</Presentacion>:null}
				{juego.descripcion}
			</ContainerPresentacion>
			

		</Container>
		)
} 